import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
const Points = props => {
  const $ = _c(11);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M10 3.50439V4.44439" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t1 = <path d="M5.40674 5.40662L6.07174 6.07162" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M3.50446 9.99994H4.44446" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M5.40674 14.5933L6.07174 13.9283" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M10 16.4955V15.5555" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t5 = <path d="M14.5933 14.5933L13.9283 13.9283" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t6 = <path d="M16.4955 9.99994H15.5555" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t7 = <path d="M14.5933 5.40662L13.9283 6.07162" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />;
    t8 = <path fillRule="evenodd" clipRule="evenodd" d="M10.625 7C10.625 6.65482 10.3452 6.375 10 6.375C9.65482 6.375 9.375 6.65482 9.375 7C9.375 8.31168 8.31168 9.375 7 9.375C6.65482 9.375 6.375 9.65482 6.375 10C6.375 10.3452 6.65482 10.625 7 10.625C8.31168 10.625 9.375 11.6883 9.375 13C9.375 13.3452 9.65482 13.625 10 13.625C10.3452 13.625 10.625 13.3452 10.625 13C10.625 11.6883 11.6883 10.625 13 10.625C13.3452 10.625 13.625 10.3452 13.625 10C13.625 9.65482 13.3452 9.375 13 9.375C11.6883 9.375 10.625 8.31168 10.625 7Z" fill="currentColor" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] !== props) {
    t9 = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t0}{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}</svg>;
    $[9] = props;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  return t9;
};
export default Points;